import React from "react";
import { useNavigate } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { PACKAGES } from "@/data/content";
import { Leaf, TrendUp, Rocket, Crown, Check } from "@phosphor-icons/react";

const ICONS = { Leaf, TrendUp, Rocket, Crown };

export const Pricing = () => {
  const navigate = useNavigate();
  return (
    <section id="packages" data-testid="packages-section" className="py-24 md:py-36 bg-navy">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-6">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Monthly Packages</p>
            <h2 className="font-heading font-light text-4xl sm:text-5xl lg:text-6xl text-[#F6F4F0] leading-tight">
              Retainers built to scale with your ambition.
            </h2>
            <p className="text-[#E5E7EB] font-light mt-6 leading-relaxed">
              Pricing is finalized monthly, once we&apos;ve discussed your campaign and outline together. Every package can be tailored — book a consultation for a custom plan.
            </p>
          </Reveal>
        </div>

        <div id="pricing" className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mt-16">
          {PACKAGES.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <Reveal key={p.key} delay={i * 0.08}>
                <div
                  data-testid={`package-${p.key}`}
                  className={`relative h-full flex flex-col p-8 border transition-all duration-300 hover:-translate-y-1.5 ${
                    p.featured
                      ? "bg-[#101f30] border-[#C8A96A]"
                      : "bg-[#0D1B2A] border-[#F6F4F0]/12 hover:border-[#C8A96A]/50"
                  }`}
                >
                  {p.featured && (
                    <span className="absolute -top-3 left-8 bg-[#C8A96A] text-[#0D1B2A] text-[10px] uppercase tracking-[0.2em] px-3 py-1 font-semibold">
                      Most Popular
                    </span>
                  )}
                  <Icon size={30} weight="thin" className="text-gold mb-6" />
                  <h3 className="font-heading text-2xl text-[#F6F4F0]">{p.name}</h3>
                  <p className="text-[#6B7280] text-xs mt-2 mb-6 leading-relaxed min-h-[48px]">{p.tagline}</p>
                  <div className="flex items-baseline gap-1 mb-8">
                    <span className="font-heading text-4xl text-[#F6F4F0]">{p.price}</span>
                    <span className="text-[#6B7280] text-sm">{p.cadence}</span>
                  </div>

                  <ul className="space-y-3 mb-8 flex-1">
                    {p.features.map((f) => (
                      <li key={f} className="flex gap-3 text-sm text-[#E5E7EB] font-light">
                        <Check size={16} className="text-gold shrink-0 mt-1" /> {f}
                      </li>
                    ))}
                  </ul>

                  <button
                    data-testid={`package-${p.key}-btn`}
                    onClick={() => navigate("/consultation")}
                    className={`w-full text-xs uppercase tracking-[0.2em] py-4 font-medium transition-colors duration-300 ${
                      p.featured
                        ? "bg-[#C8A96A] text-[#0D1B2A] hover:bg-[#F6F4F0]"
                        : "border border-[#C8A96A] text-gold hover:bg-[#C8A96A] hover:text-[#0D1B2A]"
                    }`}
                  >
                    Get Started
                  </button>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
